// https://stackoverflow.com/questions/2387136/cross-browser-method-to-determine-vertical-scroll-percentage-in-javascript

const $body = $('body'),
    $progressBar = $('.scroll-progress-bar__fill'),
    $animateSections = $('.section:not(:first-of-type), .site-footer'),
    animationOffset = viewport().height/5*4;

let lastScrollTop = 0;

function getScrollPercent() {
    let h = document.documentElement,
        b = document.body,
        st = 'scrollTop',
        sh = 'scrollHeight';

    return (h[st]||b[st]) / ((h[sh]||b[sh]) - h.clientHeight) * 100;
}

window.addEventListener('scroll', function () {
    let scrollPercentage = getScrollPercent();

    // setting limits
    if (scrollPercentage < 0) scrollPercentage = 0;
    if (scrollPercentage > 100) scrollPercentage = 100;

    // updating progress bar
    if (viewport().width > 991) {
        $progressBar.css('transform', 'scaleX(' + scrollPercentage + '%)');
    }

    // set scroll direction class on body
    let scrollTop = $(this).scrollTop();

    if (scrollTop < lastScrollTop) {
        // scrolling up
        $body.removeClass('scrolling-down').addClass('scrolling-up');
    } else {
        // scrolling down
        $body.removeClass('scrolling-up').addClass('scrolling-down');
    }

    lastScrollTop = scrollTop;
});

$animateSections.each(function () {
    let $section = $(this);

    $section.addClass('hide-for-fade-in');

    if ($section.offset().top < (viewport().height + $(window).scrollTop())) {
        $section.addClass('fade-in');
    }

    window.addEventListener('scroll', function () {
        let scroll = window.scrollY;

        if (scroll > $section.offset().top - animationOffset) {
            $section.addClass('fade-in');
        }
    });
});

if ($('html').height() < viewport().height) {
    $animateSections.each(function () {
        $(this).addClass('fade-in');
    });
}